type ApiUrlClassExtension<T> = T & {
  apiUrl: string;
};
export const setApiUrl = <T>(target: T, value: string) =>
  ((target as ApiUrlClassExtension<T>).apiUrl = value);
export const getApiUrl = <T>(target: T) =>
  (target as ApiUrlClassExtension<T>).apiUrl;
